<div class="container" [style.width.px]="size()" [style.height.px]="size()">
  <ng-container *ngTemplateOutlet="markerTemplate"></ng-container>

  @if (expanded() != null) {
    <ng-container
      *ngTemplateOutlet="markerTemplate; context: { expand: true }"
    ></ng-container>
  }

  @if (action(); as action) {
    @let badgeSize = size() === 32 ? 16 : 14;
    @let iconSize = isHandlingPoint() ? (size() === 32 ? 10 : 8) : badgeSize;

    <div
      class="action {{ status() }} {{ color() }}"
      [class.handling-point]="isHandlingPoint()"
      [class.proposition]="proposition()"
      [class.spin]="action.animate === 'spin'"
      [style.width.px]="badgeSize"
      [style.height.px]="badgeSize"
      [onyxTooltip]="action.tooltip"
    >
      <onyx-icon
        [class.opacity]="action.animate === 'opacity'"
        [name]="action.icon"
        [size]="iconSize"
        [frame]="
          isHandlingPoint() ? iconSize : badgeSize - (proposition() ? 0 : 2)
        "
      ></onyx-icon>
    </div>
  }
</div>

<ng-template let-expand="expand" #markerTemplate>
  @if (pointLetter(); as letter) {
    <span
      [class]="[
        'marker',
        'letter',
        'f-semibold',
        status(),
        markerColor() ?? color(),
      ]"
      [class.f-paragraph-m]="size() === 32"
      [class.f-body-l]="size() === 24"
      [class.dissolve-effect]="dissolveEffect()"
      [class.proposition]="proposition()"
      [class.hover]="expand"
      [class.expanded]="expanded()"
      [class.delegation]="isDelegation()"
      [style.width.px]="size()"
      [style.height.px]="size()"
    >
      {{ letter }}
    </span>
  } @else if (icon(); as icon) {
    <onyx-icon
      class="marker {{ status() }} {{ markerColor() ?? color() }}"
      [class.result]="variant() === 'result'"
      [class.dissolve-effect]="dissolveEffect()"
      [class.proposition]="proposition()"
      [class.hover]="expand"
      [class.expanded]="expanded()"
      [class.delegation]="isDelegation()"
      [name]="
        !expand
          ? icon
          : expanded()
            ? 'arrow-alt-up-outlined'
            : 'arrow-alt-down-outlined'
      "
      [size]="
        iconSize() ??
        (!expand ? (size() === 32 ? 20 : 14) : Math.floor(size() * 0.625))
      "
      [frame]="size()"
    ></onyx-icon>
  }
</ng-template>
